import { getAgentUrl } from './agent-url'
import { authHeaders } from './auth-headers'

export interface AccountInfo {
  plan: string
  jobsPerMonth: number
  jobsUsed: number
  jobsRemaining: number
  apiUsage: {
    totalCalls: number
    totalTokens: number
    estimatedCostUsd: number
  }
  memberSince: string
}

export async function fetchAccountInfo(): Promise<AccountInfo> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...await authHeaders(),
  }

  const res = await fetch(`${await getAgentUrl()}/api/account`, { headers })
  if (!res.ok) {
    throw new Error('Failed to fetch account info')
  }
  return res.json()
}
